var _style, _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosaune(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000030464928754361201860000005048099792570817981_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 34,
    height: 34
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100350820792330047070000012346788381573577096_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000100350820792330047070000012346788381573577096_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,7.4c-1.7-1.7-4.6-1.7-6.3,0l-7.7,7.7c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0l7.7-7.7c1.3-1.3,3.5-1.3,4.9,0 c1.3,1.3,1.3,3.5,0,4.9l-2.8,2.8c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0l2.8-2.8C34.4,12,34.4,9.2,32.7,7.4L32.7,7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,17.2l-9.4,9.4L17.7,26l13.6-13.6c1-1,1-2.6,0-3.6c-1-1-2.6-1-3.6,0L8.4,28.1c-0.8,0.8-1.9,1.3-3.1,1.3 c-1.2,0-2.3-0.5-3.1-1.3C1.5,27.3,1,26.2,1,25s0.5-2.3,1.3-3.1L5.2,19c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0l-2.9,2.9 c-2.1,2.1-2.1,5.5,0,7.6c1,1,2.4,1.6,3.8,1.6s2.8-0.6,3.8-1.6l9.1-9.1l2.2,2.2l-3.6,3.6l-1.3,0.5c-0.1,0-0.1,0.1-0.2,0.1l-0.7,0.7 c-0.4,0.4-0.4,1,0,1.4l1.6,1.6c0.4,0.4,1,0.4,1.4,0l0.7-0.7c0,0,0.1-0.1,0.1-0.2l0.5-1.3l9.7-9.7c0.2-0.2,0.2-0.5,0-0.7 C28.3,17,28,17,27.8,17.2z M28.5,9.5c0.3-0.3,0.7-0.4,1.1-0.4c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.7,0.4,1.1 c0,0.4-0.2,0.8-0.4,1.1L24,18.4l-2.2-2.2L28.5,9.5z M18.9,19.1l2.2-2.2l2.2,2.2l-2.2,2.2L18.9,19.1z M17.4,28.5l-0.7,0.7l-1.5-1.5 l0.7-0.7l1-0.4l0.9,0.9L17.4,28.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3,17.7c0.1,0,0.3-0.1,0.4-0.2C7.1,17.2,14,10.1,14,4.8l6.1,6.1c-2.1,0-4.8,1.1-7.9,3.3c-2.5,1.8-4.5,3.6-4.8,4 l-4.4,4.4c-1.3,1.3-1.3,3.5,0,4.8c0.7,0.7,1.5,1,2.4,1c0.9,0,1.8-0.3,2.4-1L18,17.2c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0 L13,20.8l-3.4-3.4c0.8-0.7,1.9-1.6,3.1-2.5c3-2.1,5.7-3.2,7.6-3.1c0.3,0,0.7-0.2,0.8-0.5c0.2-0.3,0.1-0.7-0.2-1l-6.6-6.6 c-0.3-0.3-0.6-0.3-0.9-0.2C13.2,3.8,13,4.1,13,4.5c0.1,2.6-1.7,5.8-3.3,8c-1.8,2.5-3.6,4.3-3.7,4.4C5.6,17.2,5.8,17.7,6.3,17.7 L6.3,17.7z M7.1,26.8c-0.9,0.9-2.5,0.9-3.4,0c-0.9-0.9-0.9-2.5,0-3.4l0.9-0.9L8,25.9L7.1,26.8z M12.3,21.5l-3.6,3.6l-3.4-3.4 l2.8-2.8c0.1-0.1,0.4-0.4,0.8-0.8L12.3,21.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosaune);
export default __webpack_public_path__ + "static/media/posaune.f79bad52c67774f21d1f19184c7b493d.svg";
export { ForwardRef as ReactComponent };